import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import LogoIforWilliams from "./logo-ifor-williams"

const Hero = () => {
  return (
    <section className={"mb-20"}>
      <div className={"relative py-20 md:py-36 lg:py-48"}>
        <div
          className={"absolute inset-0 bg-grey-100 -z-10"}
          aria-hidden={"true"}
        >
          <div
            className={
              "absolute bg-gradient-to-t from-navy-800 via-navy-800 to-transparent h-full w-full opacity-60 z-10"
            }
          />
          <StaticImage
            className={"absolute inset-0 w-full h-full object-cover z-0"}
            src={"../images/hero.jpg"}
            alt={"Norfolk Trailers"}
          />
        </div>

        <div className={"flex flex-col items-center justify-center px-16"}>
          <div className={"mb-4"}>
            <LogoIforWilliams className={"h-28 md:h-36"} />
          </div>

          <h1
            className={
              "text-4xl lg:text-5xl text-white font-bold text-center mb-4"
            }
          >
            Norfolk's sole distributor of Ifor Williams trailers
          </h1>
          <p
            className={
              "max-w-3xl text-xl lg:text-2xl text-white font-light text-center px-10"
            }
          >
            Based at Hellesdon Business Park to the North of Norwich, we stock a
            wide range of new and used Ifor Williams trailers.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Hero
